// StripeContainer.js
import React from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import CardDetail from './CardDetail';

const PUBLIC_KEY=process.env.REACT_APP_PAYMENT_KEY
const stripePromise = loadStripe(PUBLIC_KEY);


const ELEMENTS_OPTIONS = {
  fonts: [
    {
      cssSrc: "https://fonts.googleapis.com/css2?family=Nunito+Sans:wght@400;600;700&display=swap",
    },
  ],
};

const StripeContainer = ({price}) => {
  return (
     <Elements stripe={stripePromise} options={ELEMENTS_OPTIONS}>
      <CardDetail price={price}/>
    </Elements>
  );
};

export default StripeContainer;
